import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, integerField, buttonField} from '../../core/redux/form'
import {autocompleteMatcher, displayPrediction, highlightPrediction, addressField} from '../../core/google/places'
import Icon from '../../core/components/Icon'
import StaticMap, {circlePath} from '../../core/components/StaticMap'
import TypeaheadInput from '../../core/components/TypeaheadInput'
import config from '../../config'
import {DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED, sendDefineInterventionZoneForInterventionPeriodCmd, updateDefineInterventionZoneForInterventionPeriodCmd, sendRemoveInterventionZoneFromInterventionPeriodCmd, loadProvider, loadContact} from '../actions'
import {DefineInterventionZoneForInterventionPeriodCmd} from '../models'
import i18n from '../i18n'

function isContact(committed) {
    return !!committed.commitments
}

function defineCmdUpdate(interventionPeriod) {
    return {
        zone: interventionPeriod.interventionZone
    }
}

class DefineRemoveInterventionZoneFromInterventionPeriodForm extends Component {
    static propTypes = {
        committed: PropTypes.object.isRequired,
        activity: PropTypes.object.isRequired,
        interventionPeriod: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, interventionPeriod} = this.props

        const update = defineCmdUpdate(interventionPeriod)
        dispatch(updateDefineInterventionZoneForInterventionPeriodCmd(update))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.interventionPeriod != this.props.interventionPeriod) {
            const {dispatch, interventionPeriod} = nextProps

            const update = defineCmdUpdate(interventionPeriod)
            dispatch(updateDefineInterventionZoneForInterventionPeriodCmd(update))
        }
    }

    _sendDefineCmd() {
        const {dispatch, committed, activity, interventionPeriod, onSubmit} = this.props

        return dispatch(sendDefineInterventionZoneForInterventionPeriodCmd(committed._links, activity.uid, interventionPeriod.uid)).then(() => {
            return isContact(committed) && dispatch(loadContact()) || dispatch(loadProvider())
        }).then(() => {
            onSubmit()
        })
    }

    _sendRemoveCmd() {
        const {dispatch, committed, activity, interventionPeriod, onSubmit} = this.props

        return dispatch(sendRemoveInterventionZoneFromInterventionPeriodCmd(committed._links, activity.uid, interventionPeriod.uid)).then(() => {
            return isContact(committed) && dispatch(loadContact()) || dispatch(loadProvider())
        }).then(() => {
            onSubmit()
        })
    }

    render() {
        const {dispatch, form, cmd, committed, activity, interventionPeriod, ...others} = this.props

        const distanceInputAddon = (
            <span>km</span>
        )

        const zoneField = (field) => {
            if (field.value && field.value.address && field.value.range && field.value.range.value) {
                const path = circlePath(field.value.address.geoLocation, field.value.range.value)
                const value = []
                return {path, value}
            }
            
            const value = field.value && field.value.address && [field.value.address] || []
            const identify = (a) => a.geoLocation
            return {value, identify}
        }

        const distanceField = (field) => {
            const value = field.value && field.value / 1000

            function onChange(value) {
                field.onChange(value && value * 1000)
            }

            return {...field, value, onChange}
        }

        const addressTypeaheadButton = () => {
            if (cmd && cmd.zone && cmd.zone.address) {
                return (
                    <Button
                        {...buttonField(form.zone.address(), null)}>
                        <Icon icon='minus' size='xs' />
                    </Button>
                )
            }
            return (
                <Button>
                    <Icon icon='plus' size='xs' />
                </Button>
            )
        }

        return (
            <div>
                <StaticMap
                    apiKey={config.google.apiKey}
                    ratio={16/9}
                    {...zoneField(form.zone())} />
                <form>
                    <Row>
                        <Col xs={12}>
                            <TypeaheadInput
                                ref='typeahead'
                                source={autocompleteMatcher}
                                display={displayPrediction}
                                highlight={highlightPrediction}
                                placeholder={i18n.addAddress}
                                buttonAfter={addressTypeaheadButton()}
                                {...addressField(form.zone.address())} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={4} sm={3}>
                            <Input disabled
                                type='text'
                                name='number'
                                placeholder={i18n.addressNumber}
                                {...form.zone.address.number()} />
                        </Col>
                        <Col xs={8} sm={9}>
                            <Input disabled
                                type='text'
                                name='street'
                                placeholder={i18n.addressStreet}
                                {...form.zone.address.street()} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={4} sm={3}>
                            <Input disabled
                                type='text'
                                name='zipCode'
                                placeholder={i18n.addressZipCode}
                                {...form.zone.address.zipCode()} />
                        </Col>
                        <Col xs={8} sm={9}>
                            <Input disabled
                                type='text'
                                name='city'
                                placeholder={i18n.addressCity}
                                {...form.zone.address.city()} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Input
                                type='text'
                                name='distance'
                                placeholder={i18n.distance + ' *'}
                                addonAfter={distanceInputAddon}
                                {...integerField(distanceField(form.zone.range.value()))} />
                        </Col>
                    </Row>
                </form>
                <ButtonToolbar>
                    <Button
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendDefineCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.validate}
                    </Button>
                    {interventionPeriod.interventionZone && (
                        <Button
                            bsStyle='danger'
                            bsSize='large'
                            onClick={() => this._sendRemoveCmd()}>
                            {i18n.remove}
                        </Button>
                    )}
                </ButtonToolbar>
            </div>
        )
    }
}

DefineRemoveInterventionZoneFromInterventionPeriodForm = connectForm({
    target: 'cmd',
    schema: DefineInterventionZoneForInterventionPeriodCmd.schema,
    action: DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED
})(DefineRemoveInterventionZoneFromInterventionPeriodForm)

DefineRemoveInterventionZoneFromInterventionPeriodForm = connect((state) => ({
    cmd: state.provider.defineInterventionZoneForInterventionPeriodCmd,
}))(DefineRemoveInterventionZoneFromInterventionPeriodForm)

export default DefineRemoveInterventionZoneFromInterventionPeriodForm


// WEBPACK FOOTER //
// ./lib/provider/components/DefineRemoveInterventionZoneFromInterventionPeriodForm.js